import { ContactMatchingPhoneNumberSearchableText } from "./ContactMatchingPhoneNumberSearchableText";

class ContactMatchingPhoneNumberSearchFilter {
    private readonly Items: ContactMatchingPhoneNumberSearchableText[];
    public constructor(itemsToFilter: ContactMatchingPhoneNumberSearchableText[]) {
        this.Items = itemsToFilter;
    }

    private getSearchTerms(text: string): string[] {
        return text.split(" ")
            .filter(term => !IsNullOrWhiteSpace(term))
            .map(term => term.toLocaleLowerCase());
    }

    private doesItemContainAnyTerms(item: ContactMatchingPhoneNumberSearchableText, searchTerms: string[]): boolean {
        const itemTerms = item.GetSearchTerms();
        return itemTerms
            .some(term => searchTerms
                .any(search => term.contains(search))
            );
    }

    public GetItemsContaining(text: string): ContactMatchingPhoneNumberSearchableText[] {
        if (IsNullOrWhiteSpace(text)) {
            return this.Items;
        }
        const searchTerms = this.getSearchTerms(text);
        if (!searchTerms.any()) {
            return this.Items;
        }
        return this.Items
            .filter(item => this.doesItemContainAnyTerms(item, searchTerms));
    }
}

export { ContactMatchingPhoneNumberSearchFilter };
